// THIS FILE IS GENERATED, DO NOT EDIT!
/* eslint-disable */
import * as Types from '@h5s/dtos-api';

import { LocalDate, LocalDateTime, LocalTime } from '@h5s/util-date';
import { gql } from 'apollo-angular';
import { IstatGenerationParametersFragment } from '../../fragments/generated/istat-generation-parameters.fragment.generated';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type GetIstatGenerationParametersQueryVariables = Types.Exact<{
  ownerIstatId: Types.Scalars['Int']['input'];
}>;


export type GetIstatGenerationParametersQueryResult = { __typename?: 'Query', getIstatGenerationParameters: { __typename?: 'IstatGenerationParametersDTO', availableBeds: number, availableRooms: number, availableToilets: number } | null };

export const GetIstatGenerationParametersGql = gql`
    query GetIstatGenerationParameters($ownerIstatId: Int!) {
  getIstatGenerationParameters(ownerIstatId: $ownerIstatId) {
    ...IstatGenerationParameters
  }
}
    ${IstatGenerationParametersFragment}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetIstatGenerationParametersInjectable extends Apollo.Query<GetIstatGenerationParametersQueryResult, GetIstatGenerationParametersQueryVariables> {
    override document = GetIstatGenerationParametersGql;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
/* eslint-enable */